// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"201268aa","453":"fe471d5a"}[chunkId] + ".chunk.js";
};